import { Button, CircularProgress, Link, Dialog, DialogContent, Tab, Tabs, DialogActions, Container, Grid, Typography } from '@mui/material'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Yup from 'yup';
import Logo from '../components/common/Logo';
import axios from 'axios';
import TextInput from '../components/common/TextInput';
import PageContainer from '../components/PageContainer';
import { signInUser, signIn } from '../redux/actions/userActions';
import { resetPasswordRequest, loginUser, changePassword } from '../redux/api/system';
import PasswordTextInput from '../components/common/PasswordTextInput'
import { Helmet } from 'react-helmet';
import moment from "moment";
import Countdown from "react-countdown";
import OtpInput from "react-otp-input";

const Auth = ({ signIn, signInUser }) => {
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar();
    const [ resetAlert, setResetAlert ] = useState(false);
    const [ twoFA, setTwoFA ] = useState(false);
    const [ loginDetails, setLoginDetails ] = useState({});
    const [ switchLogin, setSwitchLogin ] = useState(false);
    const [ sentOTP, setSentOTP ] = useState(false);
    const [ resToken, setResToken ] = useState("");
    const [otp, setOtp] = useState('');
    // const [ loginData ]

    const baseURL = process.env.REACT_APP_SERVER_URL + '/PortalService'

    const defaultDate = moment()
        .add(1, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
    const [countdownDate, setCountdownDate] = useState(defaultDate);

    const login = async (values, { resetForm }) => {
        try {
            const res = await loginUser(values)
            setLoginDetails(values);

            if(res?.defaultPassword){
                setResToken(res.session_token);
                setSwitchLogin(true);
            }
            else if(res?.twoFactorEnabled){
                setTwoFA(true);
            }
            else{
                try {
                    const resp = await signInUser(values)
                    history.push('/');
                }
                catch(err){
                    enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
                }
                
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const resetLogin = async (values, { resetForm }) => {
            try {
                // const res = await changePassword({ userid: values.userid, password: values.password, newpassword: values.newpassword  });
                axios.request({
                    headers: { Authorization: `Bearer ${resToken}` },
                    method: 'POST',
                    url: `${baseURL}/ChangePassword`,
                    data: { userid: values.userid, password: values.password, newpassword: values.newpassword  }
                }).then(res => {
                    if(res.data.responseCode == "00"){
                        setSwitchLogin(false);
                        enqueueSnackbar('Password changes successfully')
                        resetForm();
                    }
                    else{
                        enqueueSnackbar(res?.data?.responseMessage || res?.responseMessage || 'An error occurred', { variant: 'error' })
                    }
                }).catch(err => {
                    enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
                })
                
            }
            catch (err) {
                enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
            }
    }

    const FormSchema = Yup.object().shape({
        newpassword: Yup
          .string()
          .min(8, 'Password must be 8 characters long')
          .matches(/[0-9]/, 'Password requires a number')
          .matches(/[a-z]/, 'Password requires a lowercase letter')
          .matches(/[A-Z]/, 'Password requires an uppercase letter')
          .matches(/[^\w]/, 'Password requires a symbol'),
        confirm: Yup
          .string()
          .oneOf([Yup.ref('newpassword'), null], 'Must match "New Password" field value'),
      });

    const emailResetPassword = async ({ ...values }) => {
        let payload = values;
        payload.password = '';
        try {
            const res = await resetPasswordRequest(payload);
            if(res?.responseCode === "00") {
                enqueueSnackbar('Default Password sent to your email if account exists')
            } else {
                enqueueSnackbar('An error occurred', { variant: 'error' })
            }
        }
        catch(err){
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setResetAlert(false);
        }
    };
    
    const ResendOTP = async () => {
        setSentOTP(true)
        try{
            const res = await loginUser(loginDetails);

            if(res?.responseCode === "00") {
                enqueueSnackbar('OTP Resent to your email')
            } else {
                enqueueSnackbar(res?.message || res?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch(err){
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setSentOTP(false)
        }
    };

    const HandleTwoFASubmission = async ({ ...values }) => {
        let payload = {...loginDetails, ...values};
        
        try {
            const res = await signIn(payload)
            setTwoFA(false);
            history.push('/');
        }
        catch(err){
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    };

    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            return (
                <p
                    className="text-center text-primary m-0"
                    style={{ cursor: "pointer" }}
                    onClick={async () => {
                        await ResendOTP(loginDetails);
                        setCountdownDate(
                            moment()
                                .add(1, "minutes")
                                .format("YYYY-MM-DD HH:mm:ss")
                        );
                    }}
                >
                    Click to resend OTP
                </p>
            );
        } else {
            return (
                <div className="text-center">
                    <p className="m-0">
                        Resend in {minutes}:{seconds}
                    </p>
                </div>
            );
        }
    };

    return (
        <section style={{ minHeight: '50vh' }}>
            <Helmet><title>Login | Integrated Data Sharing Portal</title></Helmet>
            <Grid container
                style={{ 
                    minHeight: '100vh',
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/img/bg/group.jpg'})`, 
                    backgroundRepeat: 'no-repeat', 
                    backgroundSize: 'cover' 
                }}
            >
                <Grid item xs={0} sm={0} lg={8} md={6} style={{ background: 'rgba(0, 0, 0, 0.25)' }}
                >
                    
                </Grid>
                {!switchLogin ? (<Grid item lg={4} md={6} xs={12} sm={12} style={{ background: 'rgba(255,255,255,0.97)' }}>
                    <Formik
                        initialValues={{ userid: '', password: '' }}
                        onSubmit={login}
                    >
                        {
                            ({ handleChange, isSubmitting  }) => (
                                <Form style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                            <Logo />
                                        </Grid>
                                        <Grid item xs={12} container spacing={3}>
                                            <Grid item xs={12}>
                                                <TextInput id="userid" label="User ID" placeholder='Enter User ID' required />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextInput id="password" label="Password" type="password" required />
                                            </Grid>
                                            <Grid item xs={12} mb={1} container className='links m-0 pt-0 text-right' justifyContent='space-between'>
                                                <Link to='#' style={{ cursor: 'pointer' }} onClick={() => setResetAlert(true)}>Forgot Password</Link>
                                            </Grid> 
                                            <Grid item xs={12}>
                                                <Button variant="contained" type='submit' disabled={isSubmitting} fullWidth>
                                                    { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Login' }
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )
                        }
                    </Formik>
                </Grid>)
                :
                (<Grid item lg={4} md={6} xs={12} sm={12} style={{ background: 'rgba(255,255,255,0.97)' }}>
                    <Formik
                      initialValues={{ userid: `${loginDetails?.userid || ''}`, password: `${loginDetails?.password || ''}`, newpassword: '', confirm: '' }}
                      onSubmit={resetLogin}
                      validationSchema={FormSchema}
                    >
                        {
                          ({ handleChange, isSubmitting, values  }) => (
                            <Form style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                  <Logo />
                                </Grid>
                                <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                  <Tabs value={0} centered >
                                    <Tab label="Password Reset" />
                                    <Tab label="Back" onClick={() => setSwitchLogin(false)} />
                                  </Tabs>
                                </Grid>
                                
                                <Grid item xs={12} container spacing={3}>
                                  <Grid item xs={12}>
                                      <TextInput id="userid" label="User ID" readOnly required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <TextInput id="password" label="Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <PasswordTextInput id="newpassword" label="New Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <PasswordTextInput id="confirm" label="Confirm Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Button variant="contained" type='submit' disabled={isSubmitting} fullWidth>
                                        { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Login' }
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Form>
                          )
                        }
                    </Formik>
                </Grid>)}
            </Grid>
            <Dialog
                open={Boolean(resetAlert)}
                keepMounted
                disableEscapeKeyDown
            >
                <DialogContent>
                    
                    <h2 className='mb-0 mt-0'>Email Password Reset</h2>
                    <p className='mt-05'> If user exists, an email will be sent to you with a temporary password.</p>

                    <Formik
                        initialValues={{ userid: '' }}
                        validationSchema={Yup.object().shape({
                            userid: Yup.string().required('Email Address is required.'),
                        })}
                        onSubmit={emailResetPassword}
                    >
                        {({ isSubmitting, values }) => (
                            <Form>
                                <Grid container spacing={3} paddingY={0}>
                                    <Grid item xs={12}>
                                        <TextInput id='userid' required label='Email' value={values.userid} placeholder='Enter Email Address' />
                                    </Grid>
                                </Grid>
                                
                                <DialogActions className='no-padding pb-0 pt-1'>
                                    <Button onClick={() => { setResetAlert(false) }} variant='contained' color='secondary' fullWidth>Cancel</Button>
                                    <Button variant="contained" type='submit' disabled={isSubmitting} fullWidth>
                                        { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Reset' }
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
            <Dialog
                open={twoFA}
                keepMounted
                // maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    {/* <p className='mt-05'> Check your email for OTP code.</p> */}
                    <Formik
                        enableReinitialize
                        initialValues={{ opt: "" }}
                        onSubmit={HandleTwoFASubmission}
                    >
                        {({values, isSubmitting, setFieldValue }) => (
                            <Form>
                                <Grid container spacing={3} style={{ flex: 1 }} paddingY={0}>
                                    <Grid item xs={12}>
                                        <Typography fontWeight="bold" textAlign="center" variant="h6" fontSize={20} mt={1} >
                                            OTP Verification
                                        </Typography>
                                        <Typography textAlign="center" fontSize={14} mt={0} >
                                            Kindly enter OTP sent to{" "}
                                            <span className="text-primary">
                                                {values.username}
                                            </span>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/* <TextInput id='otp' value={values.opt} required label='OTP' placeholder='Enter The OPT Number' /> */}
                                        <OtpInput 
                                            value={values?.otp} 
                                            onChange={(e) => setFieldValue("otp", e)}
                                            numInputs={5}
                                            renderSeparator={
                                                <span
                                                    style={{
                                                        display: "inline-block",
                                                        margin: md ? ".7rem" : "0.5rem",
                                                    }}
                                                >
                                                    -
                                                </span>
                                            }
                                            containerStyle={{
                                                width: "100%",
                                                justifyContent: "center",
                                            }}
                                            inputStyle={{
                                                borderRadius: "7px",
                                                border: "0.5px solid grey",
                                                width: md ? "6rem" : "7.5rem",
                                                padding: md ? "2rem" : "auto",
                                            }}
                                            renderInput={(props) => <input
                                                 {...props} />}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className='mt-2'>
                                        {countdownDate ? (
                                            <Countdown
                                                date={countdownDate}
                                                renderer={renderer}
                                                onComplete={() => setCountdownDate(null) }
                                            />
                                        ) : (
                                            <p
                                                className="text-center text-primary m-0"
                                                style={{ cursor: "pointer" }}
                                                onClick={async () => {
                                                    await ResendOTP(loginDetails);
                                                    setCountdownDate(
                                                        moment()
                                                            .add(1, "minutes")
                                                            .format(
                                                                "YYYY-MM-DD HH:mm:ss"
                                                            )
                                                    );
                                                }}
                                            >
                                                Click to resend OTP
                                            </p>
                                        )}
                                    </Grid>
                                <DialogActions className='pb-2 pt-2'>
                                    <Button onClick={() => { setTwoFA(false) }} variant='contained' color='secondary' className='mr-1' fullWidth>Cancel</Button>
                                    {/* <Button variant="contained" style={{ wordWrap: 'normal' }} onClick={ResendOTP} fullWidth>
                                        { sentOTP ? <CircularProgress size={15} color='inherit' /> : 'Resend OPT' }
                                    </Button> */}
                                    <Button variant="contained" type='submit' fullWidth
                                        disabled={Boolean(values?.otp?.length !== 5) || isSubmitting}
                                    >
                                        { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Submit' }
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </section>
    )
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ signIn, signInUser },dispatch)
}

export default connect(({ user }) => ({ user }), mapDispatchToProps)(Auth)